Service = App.loadClass 'core::Angular/Service'
Sidebar = App.loadClass 'core::Angular/ReportFilters/Sidebar'

###
To use inject FilterService into filter/sidebar controller
and assign it to @scope.service. Then set beforeApply,
defintions (via setDefinitions()) and filter_url.
Pass the same service into you report controller
then $watch for the filters to be changed.
###
class exports.FilterService extends Service

    constructor: (@http) ->
        @sidebar = null
        @beforeApply = null
        @current_filters = null
        @filter_url = null
        @fetching_filters = false


    setDefinitions: (definitions) =>
        @sidebar = new Sidebar(definitions)
        @applyFilters()
        @fetchFilters()


    # Refresh filters from the backend
    fetchFilters: (url = null, cb = null, turnOffFetching = true, search = {}) =>
        if not url?
            url = @filter_url
        @filter_url = url

        # Jsonize filters and include search text
        json_ready = @sidebar.jsonize(true)
        json_ready.search = search
        json = angular.toJson(json_ready)

        # send request to fetch filter options
        if turnOffFetching
            @fetching_filters = true

        @http.post(url, query: json).then (response) =>
            jsr = response.data
            @sidebar.populateSidebar jsr.data, cb

            # I'm not sure why but the scope doesn't recoginize
            # that fetching has changed. We manually call it here.
            if turnOffFetching
                @fetching_filters = false


    # Call when clicking the Apply Filters button
    applyFilters: () =>
        doApply = @beforeApply?() ? true
        if doApply
            @current_filters = @sidebar.jsonize(true).filters


    searchFilters: (filter, text) =>
        # Prevent the search filter from running on initialization
        if @fetching_filters is false
            search = "#{filter.name}": text
            @fetchFilters(null, null, false, search)


    # Clear all selected Filters
    clearFilters: () =>
        @sidebar.clearFilters()
        @fetchFilters()
